var _path, _path2, _path3, _path4, _path5, _path6, _g, _ellipse, _ellipse2, _ellipse3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTempMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 71,
    viewBox: "0 0 82 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3655 35.1155C35.8442 34.5943 34.9991 34.5943 34.4779 35.1155V35.1156C33.9566 35.6368 33.9566 36.4819 34.4779 37.0032L37.6105 40.1358C38.1317 40.657 38.9768 40.657 39.4981 40.1358C40.0193 39.6145 40.0193 38.7694 39.4981 38.2482L36.3655 35.1155Z",
    fill: "#101518"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0686 43.8187C44.5474 43.2974 43.7022 43.2974 43.181 43.8187C42.6597 44.34 42.6597 45.1851 43.181 45.7062L46.3137 48.8389C46.8349 49.3601 47.68 49.3602 48.2012 48.8389V48.8389C48.7225 48.3176 48.7225 47.4725 48.2012 46.9513L45.0686 43.8187Z",
    fill: "#101518"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.181 40.1358C43.7022 40.657 44.5474 40.657 45.0686 40.1358L48.2012 37.0032C48.7225 36.4819 48.7225 35.6368 48.2012 35.1156V35.1155C47.68 34.5943 46.8349 34.5943 46.3137 35.1156L43.181 38.2482C42.6597 38.7694 42.6597 39.6145 43.181 40.1358Z",
    fill: "#101518"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4981 43.8187C38.9768 43.2974 38.1317 43.2974 37.6105 43.8187L34.4779 46.9513C33.9566 47.4725 33.9566 48.3177 34.4779 48.8389C34.9991 49.3602 35.8442 49.3602 36.3655 48.8389L39.4981 45.7063C40.0193 45.185 40.0193 44.3399 39.4981 43.8187V43.8187Z",
    fill: "#101518"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4957 69.6674C66.2855 69.7061 64.4622 67.9252 64.4233 65.6897C64.399 64.2908 65.9427 62.1438 65.9427 62.1438C70.317 56.4971 72.8731 49.3506 72.7385 41.618C72.4273 23.7337 57.8413 9.48665 40.1599 9.79624C22.4784 10.1058 8.39695 24.8549 8.70816 42.7392C8.83811 50.2071 11.4571 57.0409 15.7511 62.4454C16.5663 63.1716 17.0883 64.2289 17.109 65.4138C17.1479 67.6494 15.3877 69.493 13.1775 69.5317C11.837 69.5552 10.6388 68.9093 9.89472 67.8986L9.85063 67.9373C4.28006 61.1166 0.870225 52.4112 0.704361 42.8793C0.315356 20.5239 17.9171 2.08764 40.019 1.70065C62.1208 1.31366 80.3533 19.1225 80.7423 41.4779C80.9113 51.192 77.6834 60.1661 72.1654 67.2409C72.1654 67.2409 70.1279 69.6388 68.4957 69.6674Z",
    fill: "#F1F1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4206 13.9488C51.623 11.2126 46.064 9.69286 40.1599 9.79624C22.4784 10.1058 8.39695 24.8549 8.70816 42.7392C8.83811 50.2071 11.4571 57.0409 15.7511 62.4454C16.5663 63.1716 17.0883 64.2289 17.109 65.4138C17.1479 67.6494 15.3877 69.493 13.1775 69.5317C11.837 69.5552 10.6388 68.9093 9.89472 67.8986L9.85063 67.9373C4.28006 61.1166 0.870225 52.4112 0.704361 42.8793C0.315356 20.5239 17.9171 2.08764 40.019 1.70065C47.4525 1.5705 54.4483 3.49861 60.4749 6.9657C66.4396 10.3972 49.4566 6.0463 48.1318 7.61438C46.8153 9.17266 61.1906 16.6693 56.4206 13.9488Z",
    fill: "url(#paint0_linear_95_18198)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_95_18198)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5527,
    cy: 8.97249,
    rx: 7.27734,
    ry: 7.27522,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5533,
    cy: 8.97252,
    rx: 5.82187,
    ry: 5.82018,
    fill: "url(#paint1_radial_95_18198)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3441,
    cy: 20.6123,
    rx: 1.4554,
    ry: 1.45504,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.24934,
    cy: 30.0703,
    rx: 1.4554,
    ry: 1.45504,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_95_18198",
    x: 45.8249,
    y: 0.60937,
    width: 17.4557,
    height: 17.4518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.362632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.725264
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.64268 0 0 0 0 0.645461 0 0 0 0 0.693133 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_95_18198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_95_18198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_18198",
    x1: 18.1138,
    y1: 82.5993,
    x2: 69.6884,
    y2: 64.0729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8773"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_95_18198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5533 9.07667) rotate(90) scale(5.71603 5.71769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempMode);
export default __webpack_public_path__ + "static/media/temp-mode.730489316b9a6be3818a7cb662e0d042.svg";
export { ForwardRef as ReactComponent };